import { useQueryClient, UseMutationResult } from '@tanstack/react-query'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { usePortalMutation } from 'src/Libs/api'
import { completeInstallation } from 'src/Libs/installation-details/api/installation-details.api'
import { detailedInstallationQueryKey } from 'src/Libs/installation-details/hooks'

interface UseCompleteInstallationParams {
  onSuccess?: (vars: CompleteInstallationVariables) => void | Promise<void>
  onError?: (vars: CompleteInstallationVariables) => void
}

interface CompleteInstallationVariables {
  installationId?: number | string
}

type UseCompleteInstallationReturnType = (data: UseCompleteInstallationParams) => UseMutationResult<null, unknown, CompleteInstallationVariables>

export const useCompleteInstallation: UseCompleteInstallationReturnType = ({ onError, onSuccess }) => {
  const authFetch = useAuthFetchWithResponse()
  const queryClient = useQueryClient()

  const mutationResult = usePortalMutation({
    mutationFn: (vars: CompleteInstallationVariables) => completeInstallation(vars.installationId, authFetch),
    onSuccess: (_, vars) => {
      if (vars.installationId !== undefined) {
        queryClient.removeQueries({ queryKey: detailedInstallationQueryKey(Number(vars.installationId)), exact: true })
      }

      return onSuccess?.(vars)
    },
    onError: (_, vars) => onError?.(vars),
  })

  return mutationResult
}
